module.exports = __webpack_public_path__ + "img/Bear29.5da4da4d.jpg";